import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import Header from '../../components/ui/Header';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import { initSmoothScroll } from '../../utils/smoothScroll';

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Check authentication status on component mount
  useEffect(() => {
    checkAuthStatus();
    initSmoothScroll();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const response = await fetch('/backend/api/admin-auth.php?action=check', {
        credentials: 'include'
      });
      const data = await response.json();
      
      if (data.success && data.logged_in) {
        setIsAuthenticated(true);
        setUser(data.user);
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };

  if (isLoading) {
    return (
      <>
        <Helmet>
          <title>Admin Panel | PC Centar</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="min-h-screen page-background">
          <Header />
          <main className="pt-header flex items-center justify-center">
            <div className="text-center">
              <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-muted-foreground">Provera autentifikacije...</p>
            </div>
          </main>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Admin Panel | PC Centar</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen page-background">
        <Header />
        
        <main className="pt-header">
          {isAuthenticated ? (
            <AdminDashboard user={user} onLogout={handleLogout} />
          ) : (
            <AdminLogin onLogin={handleLogin} />
          )}
        </main>
      </div>
    </>
  );
};

export default AdminPage;